import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { NEWSLETTER } from '@/constants/testIds';

export function InlineNewsletter({ ctaLabel = 'Tune in' }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null); setMsg(null);
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError('Please enter a valid email.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post('/subscribe', { email: trimmed });
      setMsg(data.message || 'Subscribed.');
      setEmail('');
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-2 w-full">
      <div className="flex items-stretch gap-2">
        <input
          data-testid={NEWSLETTER.emailInput}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="enter your email"
          disabled={loading}
          className="pg-input flex-1 rounded-full px-5 py-2.5 text-sm placeholder:text-[var(--pg-ink-faint)]"
          required
        />
        <button
          data-testid={NEWSLETTER.submitButton}
          type="submit"
          disabled={loading}
          className="pg-btn-emerald disabled:opacity-60"
        >
          {loading ? '…' : ctaLabel}
        </button>
      </div>
      {msg && (
        <motion.p
          data-testid={NEWSLETTER.successMessage}
          initial={{ opacity: 1, y: -4 }} animate={{ opacity: 1, y: 0 }}
          className="text-xs text-[var(--pg-emerald)] font-mono"
        >{msg}</motion.p>
      )}
      {error && (
        <motion.p
          data-testid={NEWSLETTER.errorMessage}
          initial={{ opacity: 1, y: -4 }} animate={{ opacity: 1, y: 0 }}
          className="text-xs text-[var(--pg-neon-pink)] font-mono"
        >{error}</motion.p>
      )}
    </form>
  );
}
